import { useState } from "react";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import Table, { Column } from "../../../Components/Tables/Table";
import { invStatusDataList } from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";

class invStatus {
  public itemCode: string;
  public desc: string;
  public qtyhand: string;
  public recQty: string;
  public avlNow: string;
  public expQty: string;
  constructor() {
    this.itemCode = "";
    this.desc = "";
    this.qtyhand = "";
    this.recQty = "";
    this.avlNow = "";
    this.expQty = "";
  }
}
export default function StatusOverview() {
  const pageName = "Inventory Status";
  const [invFilterDataList, setInvFilterDataList] = useState<invStatus[]>(invStatusDataList);
  const navigation = useNavigate();
  const [isAddButtonDisable, setAddButtonDisable] = useState(false);
  const handleGlobalFilter = () => {
    // if (data.trim() === "") {
    //   setInvFilterDataList([]);
    // } else {
    //   const filterData = invStatusDataList.filter((item) =>
    //     item.itemCode.toLowerCase().includes(data.toLowerCase())
    //   );
    //   setInvFilterDataList(filterData);
    // }
  };
  const handleGlobalSearch = (data:string) => {
        const filterData = invStatusDataList.filter((item) =>
          item.itemCode.toLowerCase().includes(data.toLowerCase())
        );
        setInvFilterDataList(filterData);
   };
  const handleRowClick = (data: any) => {
    navigation(`/inventory/status-overview/details/${data.itemCode}`);
  };
  const handelSelectRows = (selectedRow: Set<number>) => {
    setAddButtonDisable(selectedRow.size > 0);
  };
  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log('Page changed to:', page);
  };
  const columns: Column[] = [
    {
      name: "Item Code ",
      selector: (row: { itemCode: string }) => (
        <span onClick={() => handleRowClick(row)} className="cursor-pointer text-primary ">
          {row.itemCode}
        </span>
      ),
      enableSorting: true,
    },
    {
      name: "Item Desc ",
      selector: (row: { desc: string }) =>(
        <span   title={row.desc.length > 15 ? row.desc : ""}>
        {row.desc.length > 15
          ? `${row.desc.slice(0, 15)}...`
          : row.desc}
      </span>
      ), enableSorting: true
    },
    {
      name: "Qty On Hand",
      selector: (row: { qtyhand: string }) => row.qtyhand, enableSorting: true,
    },
    {
      name: "Qty Reserved",
      selector: (row: { recQty: string }) => row.recQty, enableSorting: true,
    },
    {
      name: "Qty Available Now ",
      selector: (row: { avlNow: string }) => row.avlNow, enableSorting: true,
    },
    {
      name: "Expected Qty",
      selector: (row: { expQty: string }) => row.expQty, enableSorting: true,
    },
    {
      name: "",

      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
        </>
      ),
    },
  ];
  return (
    <>
      <PageHeader
        listUrl="/inventory/status-overview"
        name="Status"
        viewType={false}
        isShowAllHeader={true}
        isShowBackBtn={true}
        //  handleGlobalFilter={handleGlobalFilter}
        //  handleGlobalSearch={handleGlobalSearch}
      />
      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div className="inbound-CheckIn-Table-Main-Div"></div>
      {invFilterDataList.length > 0 ? (
        <Table
          columns={columns}
          data={invFilterDataList}
           pagination={{
          recordsPerPage: 15,
          totalRecords: invFilterDataList.length,
          onCurrentPageChange: onCurrentPageChange
        }}
          onSelectedRowsChange={handelSelectRows}
          enableSorting = {true}
        />
      ) : (
        ""
      )}
    </>
  );
}
